import { Logger } from '@smiles/core-engine';
import { APIEnvs } from '@smiles/core-engine/dist/types';
import { FileEnvironment } from '../api/ProductionEnviroment';

interface EnvironmentClientKey {
  [key: string]: string;
}

type GreenBlue = 'GREEN' | 'BLUE';

type LDEnvs = APIEnvs | GreenBlue;

const EnvironmentClientKey: EnvironmentClientKey = {
  'DEV1-N': '65fdc785e85a1e0f5c651288',
  'DEV2-N': '65fdc799f3683d0f807ea6e5',
  'DEV3-N': '65fdc7c1dee0dc0fb8ba30e9',
  HML1: '65fdc7ce554b5c0fda14c420',
  HML5: '65fdc7d84dcf1e101bff77d8',
  BLUE: '65fdc7e1e85a1e0f5c6512aa',
  GREEN: '65fdc7f108d1270f6ea7c8ce',
  PRD: '65fdc7f108d1270f6ea7c8ce',
};

const getLoginEnviroment = async (forceEnviroment?: LDEnvs): Promise<LDEnvs> => {
  if(forceEnviroment) {
    return forceEnviroment;
  }

  const origin = window.location.origin.toLocaleLowerCase();

  const isHmlEnv = origin.includes('hml');
  const [hmlEnvNumber] = origin.match(/\d+/) as RegExpMatchArray || [];
  
  if(isHmlEnv) {
    return `HML${hmlEnvNumber}` as LDEnvs;
  }

  const isDevEnv = origin.includes('dev');
  const isDotEnv = origin.includes('.dev');
  const [devEnvNumber] = origin.match(/\d+/) as RegExpMatchArray || [];
  
  if(isDevEnv) {
    const dotSuffix = isDotEnv ? '-N' : '';

    return `DEV${devEnvNumber}${dotSuffix}` as LDEnvs;
  }

  const isLocalhost = origin.includes('localhost');

  if(isLocalhost) {
    Logger.info('[LDConfig][getLoginEnviroment] Using default HML5 in development enviroment. Use "forceEnviroment" to change it in development');
    return 'HML5';
  }

  const searchEnv = await FileEnvironment();
  
  const prdEnv = searchEnv.toLocaleUpperCase();

  return prdEnv as LDEnvs;
};

const getEnviromentKey = (enviroment: LDEnvs): string => {
  Logger.info('[LDConfig] using', [enviroment]);
  return EnvironmentClientKey[enviroment] || EnvironmentClientKey.PRD;
};

const urlMapping: EnvironmentClientKey = {
  'DEV1-N': '.dev1',
  'DEV2-N': '.dev2',
  'DEV3-N': '.dev3',
  HML1: '-hml1',
  HML5: '-hml5',
  BLUE: '-blue',
  GREEN: '-green',
  PRD: '-green',
}

const GetRelayBaseUrl = async (enviroment: string): Promise<string> => {
  const envUrl = urlMapping[enviroment];

  return `https://ldrelay${envUrl}.smiles.com.br`;
};

export const LDConfig = {
  EnvironmentClientKey,
  GetRelayBaseUrl,
  getLoginEnviroment,
  getEnviromentKey,
};
